export default "__VITE_ASSET__DhFHROIW__"